import axios from "axios";
import qs from "qs";
import { TouristAttraction } from "../models/TouristAttraction";
import QRCode from "qrcode";

// Fonction pour obtenir un token via OpenID Client Credentials
async function getToken(): Promise<string> {
  const url = "https://studio.retorik.ai/activital/connect/token";
  const clientId = "Retorik";
  const clientSecret = "Retorik";
  const data = {
    grant_type: "client_credentials",
    client_id: clientId,
    client_secret: clientSecret,
  };

  try {
    const response = await axios.post(url, qs.stringify(data), {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });

    return response.data.access_token; // Retourne le token d'accès
  } catch (error) {
    console.error("Erreur lors de la récupération du token:", error);
    throw error;
  }
}

// Fonction pour effectuer un appel API GET avec le token
async function getContent(contentItemId: string): Promise<any> {
  const token = await getToken(); // Récupère le token

  const url = `https://studio.retorik.ai/activital/api/content/${contentItemId}`;

  try {
    const response = await axios.get(url, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data;
  } catch (error) {
    console.error("Erreur lors de l'appel API GET:", error);
    throw error;
  }
}

function addBookingLinkAfterButton(isUsedOnBorne: any) {
  // Récupérer le contenu stocké depuis localStorage
  const storedContent = localStorage.getItem("currentContentItem");
  const host = document.querySelector("#retorik-shadow");

  if (storedContent && host && host.shadowRoot) {
    // Parser le contenu JSON
    const content: TouristAttraction = JSON.parse(storedContent);

    // Vérifier la présence du lien de réservation dans Booking
    const bookingLink = content.Booking?.ReservationLink?.Url;
    const bookingText = content.Booking?.ReservationLink?.Text;

    /*const isBorne = window.matchMedia("(min-height: 1900px)").matches;
    console.log("isKiosk :", isBorne);
    const isPortrait = window.matchMedia("(orientation: portrait)").matches;
    const isTouchScreen =
      "ontouchstart" in window || navigator.maxTouchPoints > 0;
    console.log("isPortrait :", isPortrait);
    console.log("isTouchScreen :", isTouchScreen);*/
    console.log("isUsedOnBorne :", isUsedOnBorne);
    console.log("bookingLink :", bookingLink);
    if (bookingLink) {
      if (isUsedOnBorne) {
        // Créer un élément pour le QR code
        const qrCodeElement = document.createElement("div");
        qrCodeElement.id = "qrCode";

        // Trouver le bouton après lequel insérer le QR code
        const downloadButton = host.shadowRoot.querySelector(
          'a[href^="https://studio.retorik.ai/activital/"]'
        );

        const qrcodeImg = host.shadowRoot.querySelector("img.rf-max-h-qrcode");
        if (
          qrcodeImg &&
          qrcodeImg.parentElement &&
          qrcodeImg.parentElement.parentElement &&
          qrcodeImg.parentElement.parentElement.parentElement
        ) {
          const textElement = document.createElement("p");
          textElement.textContent = "Pour réserver :";
          textElement.style.textAlign = "center"; // Centrer le texte
          // Ajouter l'élément QR code après le bouton
          qrcodeImg.parentElement.parentElement.parentElement.appendChild(
            textElement
          );
          qrcodeImg.parentElement.parentElement.parentElement.appendChild(
            qrCodeElement
          );
          qrcodeImg.parentElement.parentElement.parentElement.classList.add(
            "rf-flex-col",
            "rf-items-center"
          );
          qrcodeImg.parentElement.parentElement.remove();
          // Générer le QR code
          QRCode.toDataURL(bookingLink, (err: any, url: any) => {
            if (err) {
              console.error("Erreur lors de la génération du QR code:", err);
            } else {
              qrCodeElement.innerHTML = `<img src="${url}" alt="QR Code" style="max-width: 100%; height: auto;">`;
            }
          });
        } else if (downloadButton && downloadButton.parentElement) {
          const textElement = document.createElement("p");
          textElement.textContent = "Pour réserver :";
          textElement.style.textAlign = "center"; // Centrer le texte
          // Ajouter l'élément QR code après le bouton
          downloadButton.parentElement.appendChild(textElement);
          downloadButton.parentElement.appendChild(qrCodeElement);
          downloadButton.parentElement.classList.add(
            "rf-flex-col",
            "rf-items-center"
          );
          downloadButton.remove();
          // Générer le QR code
          QRCode.toDataURL(bookingLink, (err: any, url: any) => {
            if (err) {
              console.error("Erreur lors de la génération du QR code:", err);
            } else {
              qrCodeElement.innerHTML = `<img src="${url}" alt="QR Code" style="max-width: 100%; height: auto;">`;
            }
          });
        } else {
          console.error("Le bouton spécifié n'a pas été trouvé.");
        }
      } else {
        // Créer un élément <a> avec le lien de réservation
        const linkElement = document.createElement("a");
        linkElement.href = bookingLink;
        linkElement.textContent = bookingText ?? "Réserver"; // Texte du lien
        linkElement.target = "_blank"; // Ouvrir dans un nouvel onglet
        linkElement.className =
          "rf-px-5 rf-py-3 rf-h-fit rf-flex rf-flex-row rf-items-center rf-my-4 rf-border-2 rf-border-black rf-rounded-lg hover:rf-bg-truewhite rf-cursor-pointer rf-font-bold";

        // Trouver le bouton après lequel insérer le lien
        const downloadButton = host.shadowRoot.querySelector(
          'a[href^="https://studio.retorik.ai/activital/"]'
        );

        if (downloadButton && downloadButton.parentElement && linkElement) {
          // Ajouter le lien après le bouton
          downloadButton.parentElement.appendChild(linkElement);
          downloadButton.parentElement.classList.add(
            "rf-flex-col",
            "rf-items-center"
          );

          downloadButton.remove();
        } else {
          console.error("Le bouton spécifié n'a pas été trouvé.");
        }
      }
    } else {
      const downloadButton = host.shadowRoot.querySelector(
        'a[href^="https://studio.retorik.ai/activital/"]'
      );
      if (downloadButton) {
        downloadButton.remove();
      }
      console.log("Aucun lien de réservation trouvé dans le contenu.");
    }
  } else {
    console.log("Aucun contenu trouvé dans localStorage.");
  }
}

const customCSS = `
  #botContainer .container{
    padding: 0;
    min-width: 100%;
      min-height: 100%;
  }
  #botContainer{
    z-index: 9999;
    position: fixed !important;
    top: 0;
  }
`;
const customInjectedCSS = `
  #retorik-container {
    // height: calc(100vh - 60px) !important;
    min-height: initial !important;
    max-height: initial !important;
  }
  `;
function injectCSS() {
  const host = document.querySelector("#retorik-shadow");
  if (host && host.shadowRoot && customInjectedCSS) {
    // Inject shadow dom custom CSS
    console.log("styleToInject in Shadow", customInjectedCSS);
    const injectedStyle = document.createElement("style");
    injectedStyle.innerHTML = customInjectedCSS;
    injectedStyle.id = "customCSS";
    if (host && host.shadowRoot) host.shadowRoot.appendChild(injectedStyle);
  }

  console.log("styleToInject", customCSS);
  const style = document.createElement("style");
  style.id = "customCSS";
  style.innerHTML = customCSS;
  document.body.appendChild(style);
}

export { getContent, getToken, addBookingLinkAfterButton, injectCSS };
